import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=08a38b01"
import script from "./Quick.vue?vue&type=script&lang=js"
export * from "./Quick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a38b01')) {
      api.createRecord('08a38b01', component.options)
    } else {
      api.reload('08a38b01', component.options)
    }
    module.hot.accept("./Quick.vue?vue&type=template&id=08a38b01", function () {
      api.rerender('08a38b01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Quick.vue"
export default component.exports